import { render, staticRenderFns } from "./DCIRegister.vue?vue&type=template&id=11125834&scoped=true"
import script from "./DCIRegister.vue?vue&type=script&lang=js"
export * from "./DCIRegister.vue?vue&type=script&lang=js"
import style0 from "./DCIRegister.vue?vue&type=style&index=0&id=11125834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11125834",
  null
  
)

export default component.exports